<template>
	<div class="sa-list-component">
		<div class="sa-list-component-header">
			<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
				<b-col lg="3">
					<p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ assistitiRecordsNumber }}</p>
				</b-col>
				<b-col lg="9">
					<div style="display: flex">
						<div style="flex: 1"></div>
						<div>
							<b-pagination v-model="assistitiCurrentPage" :total-rows="assistitiRecordsNumber" :per-page="assistitiPerPage" align="right" size="sm"></b-pagination>
						</div>
						<div>
							<b-button v-b-tooltip.hover size="sm" variant="outline-secondary" title="Visualizzazione a Schede" @click="onClickVisualizzazione('card')" class="mr-1 no-text">
								<i class="fas fa-grip-horizontal"></i>
							</b-button>
							<b-button v-b-tooltip.hover size="sm" variant="outline-secondary" title="Visualizzazione a Card" @click="onClickVisualizzazione('list')" class="mr-1 no-text">
								<i class="fas fa-list"></i>
							</b-button>
						</div>
					</div>
				</b-col>
			</b-row>
		</div>
		<div class="sa-list-component-body">
			<div class="b-table-sticky-header">
				<b-table sticky-header ref="table" stacked="lg" striped hover :items="assistiti" :fields="visibleFields" :current-page="1" :per-page="assistitiPerPage" sort-icon-left head-variant="light" class="sa-b-table" :tbody-tr-class="getRowClass">
					<template #cell(index)="row">
						<span> {{ (assistitiCurrentPage - 1) * assistitiPerPage + row.index + 1 }} </span>
					</template>
					<template v-slot:cell(numero)="{ item }">
						<span>{{ item.numero }}</span> <br />
						<span>{{ formatDate(item.dataRicovero) }}</span>
					</template>
					<template v-slot:cell(nominativo)="{ item }">
						<span>{{ item.cognome }} {{ item.nome }}</span>
						<span style="display: block">({{ item.identificativo }})</span>
					</template>
					<template v-slot:cell(eta)="{ item }">
						<span>{{ calcoloEta(item.dataNascita) }}</span>
					</template>
					<template v-slot:cell(presidio)="{ item }">
						<span>{{ item.denominazionePresidio }}</span>
					</template>
					<template v-slot:cell(settings)="{ item }">
						<span>{{ item.settingDescrizione }}</span>
					</template>
					<template v-slot:cell(camera)="{ item }">
						<span class="sa-table-span-label-primary">Piano: {{ item.nomePiano }}</span>
						<span class="sa-table-span-label-primary">Stanza: {{ item.nomeStanza }} </span>
						<span class="sa-table-span-label-primary">Letto: {{ item.nomeLetto }}</span>
					</template>
					<template v-slot:cell(actions)="row">
						<b-container class="bv-example-row">
							<b-button v-b-tooltip.hover size="sm" variant="outline-success" title="Cartella Paziente" @click="onOpenSchedaPaziente(row.item)" class="mr-1 no-text">
								<b-icon icon="book" variant="outline-sucess"></b-icon>
							</b-button>
							<b-button v-if="isButtonVisible && regime === 'RESIDENZIALE'" size="sm" v-b-tooltip.hover title="Cambio Posto Letto" variant="outline-success" @click="onClickRicovera(row.item)" class="mr-1 no-text">
								<font-awesome-icon icon="bed" />
							</b-button>
							<template v-if="row.item.statoAttuale === 'RICOVERATO'">
								<b-button v-b-tooltip.hover size="sm" variant="outline-purple" title="Registra Uscita" @click="onClickPresenzaUscita(row.item)" class="mr-1">
									<font-awesome-icon :icon="['fas', 'sign-out-alt']" />
								</b-button>
							</template>
							<b-button v-else v-b-tooltip.hover size="sm" variant="outline-danger" title="Registra Entrata" @click="onClickPresenzaEntrata(row.item)" class="sa-icon-rotate">
								<font-awesome-icon :icon="['fas', 'sign-in-alt']" />
							</b-button>
							<print-component v-if="isButtonVisible" :linkPrintReport="linkPrintReport(row.item)" :typeButton="'small'" :documentRepository="false"></print-component>
						</b-container>
					</template>
				</b-table>
			</div>
		</div>
		<div class="sa-list-component-footer">
			<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
				<b-col lg="3">
					<p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ assistitiRecordsNumber }}</p>
				</b-col>
				<b-col lg="9">
					<b-pagination v-model="assistitiCurrentPage" :total-rows="assistitiRecordsNumber" :per-page="assistitiPerPage" align="right" size="sm"></b-pagination>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import AssistitiMixin from "../mixinis/AssistitiMixin.js";
import UtilityMixin from "../../../utility/UtilityMixin.js";
export default {
	mixins: [AssistitiMixin, UtilityMixin],
	data() {
		return {
			rows: 0,
			visibleFields: [
				{
					label: "*",
					key: "index",
					thStyle: "width: 0.5rem",
					setting: "RESIDENZIALE,DOMICILIARE,AMBULATORIALE",
				},
				{
					label: "Stato",
					key: "statoAttuale",
					thStyle: "width: 0.4rem",
					setting: "RESIDENZIALE,DOMICILIARE,AMBULATORIALE",
				},
				{
					label: "Cod. Struttura",
					key: "codiceStruttura",
					setting: "RESIDENZIALE,DOMICILIARE,AMBULATORIALE",
				},
				{
					label: "Presidio",
					key: "denominazionePresidio",
					setting: "RESIDENZIALE,DOMICILIARE,AMBULATORIALE",
				},
				{
					label: "Numero Cartella",
					key: "numero",
					setting: "RESIDENZIALE,DOMICILIARE,AMBULATORIALE",
				},
				{
					label: "Nominativo",
					key: "nominativo",
					setting: "RESIDENZIALE,DOMICILIARE,AMBULATORIALE",
				},
				{
					label: "Regime",
					key: "regime",
					setting: "RESIDENZIALE,DOMICILIARE,AMBULATORIALE",
				},
				{
					label: "Setting/Reparto",
					key: "settingDescrizione",
					setting: "RESIDENZIALE,DOMICILIARE,AMBULATORIALE",
				},
			],
		};
	},
	mounted() {
		//this.loadAssistiti({});
	},
	watch: {
		assistitiCurrentPage() {
			this.loadAssistiti(this.assistitiCurrentPage);
		},
	},
	methods: {
		getRowClass(item) {
			let returnValue = "";
			if (item.statoAttuale === "ASSENTE") {
				returnValue = "riga-assente";
			}
			return returnValue;
		},
	},
};
</script>

<style></style>
